import React from 'react'
import { Route } from 'react-router-dom'
import { withRouter } from 'react-router'
import RootContainer from '../../containers/event/rootContainer'
import Container from '../shared/ui/container'
import DisplayContainer from '../../containers/event/displayContainer'

class EventDisplayRoute extends React.Component<any, any> {
  render() {
    return (
      <RootContainer>
        <Container maxWidth={960} css={{ ' p': { fontSize: '1em' } }}>
          <Route exact path="/" component={DisplayContainer} />
          <Route exact path="/:id" component={DisplayContainer} />
        </Container>
      </RootContainer>
    )
  }
}

export default withRouter(EventDisplayRoute)
